// extracted by mini-css-extract-plugin
export default {"vendorHeader":"vendorHeader__NjNmZ","hed":"hed__Y2MzN","vendor":"vendor__Y2UxM","info":"info__MTg2N","name":"name__NjkwZ"};